export default {
  model: {
    prop: 'model',
    event: 'sync'
  },
  props: {
    model: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    value: 'default',
  }),
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  watch: {
    model () {
      this.init()
      this.$nextTick(() => {
        // this.init()
      })
    }
  },
  methods: {
    init () {
      this.value = this.model
      this.normalize()
    },
    sync () {
      this.normalize()
      this.$emit('sync', this.value)
    },
    normalize () {}
  }
}